var jade = require("/home/romain/Cozy/cozy-proxy/client/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (alert, forgot, label, prefix, t) {
if ( alert && alert.title)
{
buf.push("<div class=\"alert\"><p><strong>" + (jade.escape(null == (jade_interp = t(prefix + ' ' + alert.title)) ? "" : jade_interp)) + "</strong></p><p>" + (jade.escape(null == (jade_interp = t(prefix + ' ' + alert.message)) ? "" : jade_interp)) + "</p></div>");
}
if ( forgot)
{
buf.push("<div class=\"recover\">");
label = t(alert && alert.status == 'success'? 'login recover again' : 'login recover')
buf.push("<a href=\"/login/forgot\" class=\"forgot\">" + (jade.escape(null == (jade_interp = label) ? "" : jade_interp)) + "</a></div>");
}}.call(this,"alert" in locals_for_with?locals_for_with.alert:typeof alert!=="undefined"?alert:undefined,"forgot" in locals_for_with?locals_for_with.forgot:typeof forgot!=="undefined"?forgot:undefined,"label" in locals_for_with?locals_for_with.label:typeof label!=="undefined"?label:undefined,"prefix" in locals_for_with?locals_for_with.prefix:typeof prefix!=="undefined"?prefix:undefined,"t" in locals_for_with?locals_for_with.t:typeof t!=="undefined"?t:undefined));;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./app/views/templates/view_auth_feedback.jade
 ** module id = 71
 ** module chunks = 1
 **/